// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"technologyIconList-module--sectionTitle--krSCG","iconList":"technologyIconList-module--iconList--3BDRF"};